Ext.define('SA.view.report.businessreport.BusinessReportColumnsMenu',{
    alias: 'widget.business-report-columns-menu',
    extend: 'Ext.menu.Menu',

    layout: 'absolute',

    initComponent() {
        var BusinessReport = SA.data.BusinessSearchTableView,
            country = SA.AppController.getCurrentCountryCode(),
            itemWidth = 260;

        this.itemWidth = itemWidth;

        this.items = BusinessReport.getColumns(country).map(column => {
            return {
                attribute: column.attribute,
                text: column.name,
                width: itemWidth,
                xtype: 'menucheckitem',

                checkHandler(item) {
                    item.up('menu').columnsChanged = true;
                }
            };
        });

        this.callParent();
    },

    afterHide() {
        this.mun(SA.Viewport, 'resize', this.onViewportResize, this);

        this.callParent(arguments);

        if (this.columnsChanged) {
            let checkedItems = this.query('[checked=true]').map(item => item.attribute),
                reportModel = this.getReportModel(),
                attributes = reportModel.getAttributes(),
                isAdd = checkedItems.some(attribute => !attributes.includes(attribute));

            if (!isAdd) {
                checkedItems = attributes.filter(attribute => checkedItems.includes(attribute));
            }

            reportModel.setAttributes(checkedItems);

            reportModel.save();
        }

        this.columnsChanged = false;
    },

    alignTo() {
        var x;

        this.callParent(arguments);

        x = this.getX();

        if (x > 10 && x + this.getWidth() > Ext.dom.Element.getViewportWidth()) {
            this.setX(10);
        }
    },

    getReportModel() {
        return this.projectView;
    },

    onShow() {
        var reportModel = this.getReportModel(),
            reportColumns = reportModel.getAttributes(),
            itemHeight = 34,
            maxItems = Math.max(10, Math.floor(Ext.dom.Element.getViewportHeight() / itemHeight - 1)),
            items = this.query('menucheckitem'),
            separators = this.query('[separator]'),
            itemCount = items.length,
            columnCount = Math.ceil(itemCount / maxItems),
            itemsPerColumn = Math.ceil(itemCount / columnCount),
            colIndex = 0,
            maxWidth = Ext.dom.Element.getViewportWidth() - 20,
            columnWidth = this.itemWidth + 1, 
            item, x, y;

        Ext.suspendLayouts();

        while (separators.length < columnCount - 1) {
            separators.push(this.add({
                cls: 'sa-menu-vertical-separator',
                minWidth: 1,
                separator: true,
                width: 1,
                x: (separators.length + 1) * columnWidth - 1,
                xtype: 'component',
                y: 0
            }));
        }

        this.setSize(Math.min(columnCount * columnWidth + 1, maxWidth), itemsPerColumn * itemHeight + 20);

        for ( ; colIndex < columnCount ; ++colIndex) {
            if (colIndex) {
                separators[colIndex - 1].setHeight(itemsPerColumn * itemHeight + 18);
            }

            for (var itemIndex = 0 ; itemIndex < itemsPerColumn ; ++itemIndex) {
                item = items[colIndex * itemsPerColumn + itemIndex];

                if (!item) {
                    break;
                }

                x = colIndex * columnWidth;
                y = itemHeight * itemIndex + 8;

                item.setLocalXY(x, y);

                item.setChecked(reportColumns.includes(item.attribute), true);
            }
        }

        Ext.resumeLayouts(true);

        this.callParent(arguments);

        this.mon(SA.Viewport, 'resize', this.onViewportResize, this, {buffer: 100});
    },

    onViewportResize() {
        var parent = this.parentItem;

        this.hide();
        this.showBy(parent, parent.menuAlign);
    }
});
